import {
  ISalePageDetailResponse,
  ISalePageProductAdditionalInformResponse,
} from '@/api/types';
import { isNil } from 'lodash-es';
import { CustomOrderFormCTA } from './CustomOrderFormCTA';
import { InstantPurchaseCTA } from './InstantPurchaseCTA';

interface OnSaleCTAProps {
  salePage?: Partial<ISalePageDetailResponse>;
  productAdditionalInforms?: ISalePageProductAdditionalInformResponse[];
  interactive?: boolean;
}

export const OnSaleCTA = ({
  salePage,
  productAdditionalInforms,
  interactive,
}: OnSaleCTAProps) => {
  if (isNil(salePage) || isNil(salePage?.id)) return null;

  return salePage.hasCustomMediaProducts ? (
    <CustomOrderFormCTA salePage={salePage} />
  ) : (
    <InstantPurchaseCTA
      salePage={salePage}
      productAdditionalInforms={productAdditionalInforms}
      interactive={interactive}
    />
  );
};
